/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import handlogo from '@app-ps/Components/Images/handimage.png';

/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const BlogPsQuote = ({ sectionContent, lang, region }) => {
  // Access the properties from the sectionContent object
  // console.log(sectionContent, 'quote');
  const { quote, decoration } = sectionContent;

  return (
    <Box w="100%" m="80px 0">
      <Flex
        display="flex"
        w="100%"
        mx="auto"
        alignItems={'center'}
        maxW="1330px"
        maxH="1240px"
      >
        {/* Image Of the Quote */}
        <Flex
          w="100%"
          maxW="1920px"
          gap={{ base: '1rem', md: '0' }}
          fontFamily="var(--FedraSansStd-book-i)"
          fontSize="18px"
          color="#28231E"
          flexDir={{
            lg: 'row',
            base: 'row',
          }}
        >
          <Box
            mx={{ base: 'auto', md: 'auto' }}
            alignItems={{ base: 'center' }}
          >
            <LazyLoadImageComponent
              w={{ lg: '93px', md: '156px', base: '70px' }}
              alt="no image found"
              title=""
              maxW={{ base: '72px', md: '93px' }}
              src={`${config.imgPath}/d/46272/1722335945-quotes-png.png`}
            />
          </Box>
          <Box
            flexDirection="column"
            display={{ base: 'block', md: 'column' }}
            pl={{ lg: '15px', md: '15px' }}
            w="100%"
            mx="auto"
            justifyContent={{ base: 'center', lg: 'normal' }}
            alignItems={{ lg: 'normal', base: 'center' }}
          >
            <Box
              maxW={{ md: '718px', sm: '754px', base: '328px' }}
              mx={{ sm: 'auto', md: 'auto' }}
              w="100%"
              as="span"
              fontFamily="var(--FedraSansStd-book-i)"
              fontSize={{ md: '22px', base: '16px' }}
              fontWeight={400}
              color="#010509"
              textAlign={{
                base: 'center',
                sm: 'center',
                md: 'center',
                lg: 'left',
              }}
              lineHeight={{ md: '40px', base: '25.6px' }}
              pr={{ base: '15px' }}
            >
              "{quote}"
            </Box>
            <Box as="span" fontWeight={'bold'}>
              <Box
                fontFamily="var(--FedraSansStd-book-i)"
                fontSize={{ md: '22px', base: '16px' }}
                fontWeight={{ md: '600', base: '' }}
                display={{ base: 'flex', lg: 'block' }}
                color="#010509"
                lineHeight={{ md: '57.6px', base: '35.2px' }}
                textAlign={{ base: 'center', lg: 'left' }}
              >
                Sadhguru
              </Box>
            </Box>
          </Box>
        </Flex>
      </Flex>

      <Box
        mixBlendMode="multiply"
        objectFit="cover"
        display="flex"
        alignItems="flex-end"
        justifyContent="flex-end"
        position="absolute"
        right="0"
        opacity={0.4}
        bottom={{ lg: '8rem', base: '150px' }}
        // width={{ base: '30%' }}
        width={{ base: '60%', md: '45%', lg: '35%' }}
      >
        <LazyLoadImageComponent
          src={handlogo}
          alt="no image"
          layout="responsive"
          width={266}
          height={557}
        />
        {/* Use percentage width for responsiveness */}
      </Box>
    </Box>
  );
};

export default BlogPsQuote;
